var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "v-if": _vm.isInRole(["admin"]) } },
    [
      _c("toolbar"),
      _vm._v(" "),
      _c("zlick-navigation"),
      _vm._v(" "),
      _c(
        "v-container",
        { attrs: { fluid: "", "text-xs-center": "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "", center: "", "justify-center": "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", sm6: "", md4: "" } },
                [
                  _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            return [
                              _c(
                                "v-switch",
                                _vm._g(
                                  {
                                    attrs: {
                                      label:
                                        "Two-Factor Authentication (2FA) : " +
                                        (_vm.twoFAEnabled ? "ON" : "OFF")
                                    },
                                    model: {
                                      value: _vm.twoFAEnabled,
                                      callback: function($$v) {
                                        _vm.twoFAEnabled = $$v
                                      },
                                      expression: "twoFAEnabled"
                                    }
                                  },
                                  on
                                )
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("toolTipTwoFA")))])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-container",
        { attrs: { fluid: "", "text-xs-center": "" } },
        [
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "500px" },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    [
                      _c("v-flex", { attrs: { xs12: "", "offset-xs0": "" } }, [
                        _c("h3", [_vm._v(_vm._s(_vm.$t("delete")))])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "blue darken-1", flat: "" },
                          nativeOn: {
                            click: function($event) {
                              return _vm.close($event)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("cancel")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "blue darken-1", flat: "" },
                          nativeOn: {
                            click: function($event) {
                              return _vm.deleteItem($event)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("confirm")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-container",
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "", center: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", "offset-xs0": "" } },
                [
                  _c(
                    "v-form",
                    { ref: "addUser", attrs: { "lazy-validation": "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          type: "email",
                          name: "user_email",
                          "validate-on-blur": "",
                          rules: [
                            function(v) {
                              return !!v || _vm.$t("email_required")
                            }
                          ],
                          label: _vm.$t("user_email"),
                          placeholder: _vm.$t("placeholderemail"),
                          required: ""
                        },
                        model: {
                          value: _vm.user_email,
                          callback: function($$v) {
                            _vm.user_email = $$v
                          },
                          expression: "user_email"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("user_name"),
                          rules: [
                            function(v) {
                              return !!v || _vm.$t("name_required")
                            }
                          ],
                          placeholder: _vm.$t("placeholdername"),
                          required: ""
                        },
                        model: {
                          value: _vm.user_name,
                          callback: function($$v) {
                            _vm.user_name = $$v
                          },
                          expression: "user_name"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-select", {
                        attrs: {
                          items: _vm.options,
                          "menu-props": { maxHeight: "400" },
                          label: "Roles",
                          rules: [
                            function(v) {
                              return !!v || _vm.$t("role_required")
                            }
                          ],
                          placeholder: _vm.$t("placeholderrole"),
                          multiple: "",
                          chips: "",
                          "persistent-hint": "",
                          required: ""
                        },
                        model: {
                          value: _vm.roles,
                          callback: function($$v) {
                            _vm.roles = $$v
                          },
                          expression: "roles"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-btn", { on: { click: _vm.addUser } }, [
                        _vm._v(_vm._s(_vm.$t("adduser")))
                      ]),
                      _vm._v(" "),
                      _c("v-btn", { on: { click: _vm.clear } }, [
                        _vm._v(_vm._s(_vm.$t("clear")))
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "https://developer.zlick.it/concepts/portal.html",
                            target: "_blank"
                          }
                        },
                        [_vm._v("Learn more about roles")]
                      ),
                      _vm._v(" "),
                      _c("br")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.error
        ? _c(
            "v-container",
            { attrs: { fluid: "", "text-xs-center": "" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "", center: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", "offset-xs0": "" } },
                    [
                      _c(
                        "v-data-table",
                        {
                          staticClass: "elevation-1",
                          attrs: {
                            headers: _vm.headers,
                            items: _vm.items,
                            "hide-actions": ""
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "items",
                                fn: function(props) {
                                  return [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "“text-xs-center”",
                                        on: {
                                          click: function($event) {
                                            return _vm.editUser(props.item)
                                          }
                                        }
                                      },
                                      [
                                        _c("a", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatUserInfo(
                                                props.item.Attributes,
                                                "email"
                                              )
                                            )
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "“text-xs-center”" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatUserInfo(
                                              props.item.Attributes,
                                              "name"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatUserInfo(
                                              props.item.Attributes,
                                              "role"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatStatus(
                                              props.item.UserStatus
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatDate(
                                              props.item.UserCreateDate
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatDate(
                                              props.item.UserLastModifiedDate
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-bottom" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "mx-0",
                                            attrs: { icon: "" }
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: { color: "pink" },
                                                on: {
                                                  click: function($event) {
                                                    _vm.showDeleteBox(
                                                      props.item.Username,
                                                      _vm.formatUserInfo(
                                                        props.item.Attributes,
                                                        "email"
                                                      )
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("delete")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1408326455
                          )
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "template",
                            { slot: "no-data" },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "primary" },
                                  on: { click: _vm.initialize }
                                },
                                [_vm._v(_vm._s(_vm.$t("reload")))]
                              )
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06094c23", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06094c23","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ManageUsers.vue
// module id = null
// module chunks = 